import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const WealthManagementSection = () => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8 }}
          className="max-w-4xl mx-auto text-center mb-12"
        >
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            <Link to="/wealth-management" className="hover:text-blue-600 transition-colors">
              Tax-Smart Wealth Management
            </Link>
          </h2>
          <p className="text-lg text-gray-700">
            🦈 Shark Shout-Out from Kevin O'Leary: "Flying blind without tax strategy? That's a wealth killer."
            <br /><br />
            Snow's Tax & Financial isn't just another firm—we're Arkansas-built, compliance-driven, & trusted by investors who demand clarity. Our holistic model fuses tax and wealth planning to eliminate blind spots & build lasting financial strength.
            <br /><br />
            📈 Grow smarter. Protect better. Partner with Snow's today.
          </p>
        </motion.div>

        <div className="relative w-full max-w-4xl mx-auto overflow-hidden rounded-2xl bg-gradient-to-r from-blue-700/20 to-blue-500/20 p-4 shadow-2xl">
          <div className="w-full h-full rounded-xl overflow-hidden">
            <div className="w-full h-full relative" style={{ paddingTop: '75.00%' }}>
              <iframe
                style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                allowTransparency="true"
                src="https://adilo.bigcommand.com/watch/9PdYwbbp"
                frameBorder="0"
                allowFullScreen
                mozallowfullscreen="true"
                webkitallowfullscreen="true"
                oallowfullscreen="true"
                msallowfullscreen="true"
                scrolling="no"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WealthManagementSection;